import { useRef, useEffect, } from "react";
import Chart from "chart.js/auto";
import { range } from "lodash";
import { Spin } from "antd";
import { STATUS } from "../../constants";
import { useContext } from "react";
import { UserContext } from "../../context";

function Chart19({ kanbanFilterInfo, status }) {
  const { parkId } = useContext(UserContext);
  const element = useRef();
  const madridData = kanbanFilterInfo.find(item => item.cloumn === 2);
  const madridCount2025 = madridData?.context[2025] || 0;
  const years = range(5).map((index) => `${2021 + index}年`);
  const counts = madridCount2025
    ? [56, 56, 56, 56, madridCount2025]
    : [0, 0, 0, 0, 0];
  useEffect(() => {
    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: years,
        datasets: [
          {
            data: parkId == 67 ? [83, 92, 96, 104, 106] : (parkId == 69 ? [5, 9, 10, 13, 15] : counts),
            fill: true,
            borderColor: "#e9c46a",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: false,
        },
      },
    });
    return () => chart.destroy();
  }, [madridData, parkId]);
  return (
    <Spin spinning={status === STATUS.idle}>
      <canvas ref={element} />
    </Spin>
  );
}

export default Chart19;
